import { render, staticRenderFns } from "./NewRegistrationDetail.vue?vue&type=template&id=6baabb17&scoped=true&"
import script from "./NewRegistrationDetail.vue?vue&type=script&lang=js&"
export * from "./NewRegistrationDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewRegistrationDetail.vue?vue&type=style&index=0&id=6baabb17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baabb17",
  null
  
)

export default component.exports